<template>
  <div class="overflow-x-auto w-full">
    <vue-excel :datas="excelData"/>
  </div>
</template>

<script>
import VueExcel from 'vue-excelview'
import axios from 'axios'

export default {
  components: {
    VueExcel,
  },
  props: {
    url: {
      type: String
    }
  },
  watch: {
    url: function (newVal, oldVal) {
      axios.get(newVal, {
        responseType: 'arraybuffer',
      })
        .then((res) => {
          // console.log(res.data)

          this.excelData = res.data
        })
    },
  },
  data() {
    return {
      excelData: '',
    }
  },
  mounted() {

  },
  methods: {
    importExcel(file) {
      // console.log('importExcel')
      // let file = file.files[0] // 使用原始的input方法需要加上这一步
      const types = file.name.split('.')[1]
      const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
      if (!fileType) {
        this.$message('格式错误！请重新选择')
        return
      }
      this.fileToBuffer(file.raw).then(tabJson => {
        // console.log(tabJson)
        // if (tabJson && tabJson.length > 0) {
        this.excelData = tabJson
        // console.log('数据:', this.xlsxJson)
        // xlsxJson就是解析出来的json数据,数据格式如下
        // [
        //   {
        //     sheetName: sheet1
        //     sheet: sheetData
        //   }
        // ]
        // }
      })
    },
    fileToBuffer(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader()
        fr.onload = e => {
          resolve(e.target.result)
        }
        fr.readAsArrayBuffer(file)
        fr.onerror = () => {
          reject(new Error('转换文件格式发生错误'))
        }
      })
    },
    file2Xce(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        reader.onload = function (e) {
          const data = e.target.result
          // this.wb = XLSX.read(data, {
          //   type: 'binary'
          // })
          // const result = []
          // this.wb.SheetNames.forEach((sheetName) => {
          //   result.push({
          //     sheetName: sheetName,
          //     sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
          //   })
          // })
          resolve(data)
        }
        reader.readAsBinaryString(file.raw)
        // reader.readAsBinaryString(file)     //使用原始input方法
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
